import { useLoginSAML } from "Hooks/useLogin";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { exchangeToken } from "Admin/Service/Auth";
import { Spin } from "antd";

const Login = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const navigate = useNavigate();
  const location = useLocation();
  const [isExchanging, setIsExchanging] = useState(false);
  
  // Only enable SAML login if no tokens in URL and no tokens in localStorage
  const hasTokensInUrl = queryParams.has("access_token") && queryParams.has("refresh_token");
  const hasTokensInStorage = localStorage.getItem(`${process.env.REACT_APP_PREFIX}_access_token`);
  const shouldEnableLogin = !hasTokensInUrl && !hasTokensInStorage;
  
  const { data } = useLoginSAML(shouldEnableLogin);


  useEffect(() => {
    const accessToken = queryParams.get("access_token");
    const refreshToken = queryParams.get("refresh_token");
    if (accessToken && refreshToken) {
      setIsExchanging(true);
      localStorage.setItem(
        `${process.env.REACT_APP_PREFIX}_admin_access_token`,
        accessToken,
      );
      localStorage.setItem(
        `${process.env.REACT_APP_PREFIX}_admin_refresh_token`,
        refreshToken,
      );
      
      exchangeToken((res) => {
        console.log(res, "exchangeToken response");
        if (res) {
          console.log(res, "exchangeToken response");
          localStorage.setItem(
            `${process.env.REACT_APP_PREFIX}_access_token`,
            res.access_token
          );
          localStorage.setItem(
            `${process.env.REACT_APP_PREFIX}_refresh_token`,
            res.refresh_token
          );
        }
        
        queryParams.delete("access_token");
        queryParams.delete("refresh_token");
        const previousPage = location.state?.previousPage || "/explore";
        navigate(previousPage);
        setIsExchanging(false);
      });
    } else {
      if (data) {
        window.location.href = data.data.redirect_url;
      }
    }
  }, [queryParams, data, navigate, location.state]);

  if (isExchanging) {
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}>
        <Spin size="large" tip="Logging in..." />
      </div>
    );
  }

  return <></>;
};

export default Login;
